module.exports = __webpack_public_path__ + "img/frontend_base_militar.7d4f2d36.jpg";